import React from "react";

import IconButton from "@mui/material/IconButton";
import { ReactComponent as VerticalDots } from "assets/icons/verticalDots.svg";
import OptionsModalBox from "../../../components/OptionsModalBox/OptionsModalBox";

import { StatusENUM } from "types/common";

type Props = {
  id: string;
  status?: StatusENUM;
  authStatus?: string;
  email?: string;
  onDisableUser?: (userId: string, status?: StatusENUM) => void;
  onEditClick?: (clinicId: string) => void;
  onAddAdminClick?: (clinicId: string) => void;
  resendInvitation?: (email: string) => void;
  onDisableClinic?: (clinicId: string, status: StatusENUM) => void;
};

const TableRow: React.FC<Props> = React.memo(
  ({
    id,
    status,
    onEditClick,
    onAddAdminClick,
    children,
    onDisableClinic,
    onDisableUser,
    resendInvitation,
    authStatus,
    email,
  }) => {
    const [isDotsDarkMode, setIsDotsDarkMode] = React.useState(false);
    const [iconElement, setIconElement] = React.useState<Element | null>(null);
    const closePopover = () => {
      setIconElement(null);
    };

    return (
      <>
        <div
          className="group w-full min-h-[54px] card rounded-xl flex items-center pl-3 font-normal text-grayDark hover:bg-bgDark hover:text-white hover:shadow-xl"
          onMouseEnter={() => setIsDotsDarkMode(true)}
          onMouseLeave={() => setIsDotsDarkMode(false)}
        >
          {children}

          <div className="w-[100px]">
            <IconButton
              size="small"
              onClick={(ev) => setIconElement(ev.target as Element)}
            >
              <VerticalDots fill={isDotsDarkMode ? "white" : "black"} />
            </IconButton>
          </div>
        </div>

        <OptionsModalBox
          anchorEl={iconElement}
          onClose={closePopover}
          onEditClick={onEditClick ? () => onEditClick(id) : undefined}
          onDisableClinic={
            onDisableClinic && status
              ? () => onDisableClinic(id, status)
              : undefined
          }
          onDisableUser={
            onDisableUser && status
              ? () => onDisableUser(id, status)
              : undefined
          }
          resendInvitation={
            resendInvitation && email
              ? () => resendInvitation(email)
              : undefined
          }
          authStatus={authStatus}
          onAddAdminClick={
            onAddAdminClick ? () => onAddAdminClick(id) : undefined
          }
          status={status}
        />
      </>
    );
  }
);

export default TableRow;
